import axios from 'axios';
import { API_AUTH_BASE_URL } from 'configs/AppConfig';
import { signOutSuccess } from 'store/slices/authSlice';
import store from '../store';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import { notification } from 'antd';

const unauthorizedCode = [400, 401, 403,404,500,508]

const service = axios.create({
  baseURL: API_AUTH_BASE_URL,
  timeout: 60000
})

// Config


// API Request interceptor
service.interceptors.request.use(config => {
	console.log("config",config)
	config.headers["Content-Type"] = "application/x-amz-json-1.1"
  	return config
}, error => {
	// Do something with request error here
	notification.error({
		message: 'Error'
	})
	Promise.reject(error)
})

// API respone interceptor
service.interceptors.response.use( (response) => {
	return response.data
}, (error) => {

	let notificationParam = {
		message: ''
	}

	// Remove token and redirect 
	if (unauthorizedCode.includes(error.response.status)) {
		notificationParam.message = 'Autenticazione fallita'
		notificationParam.description = 'Effettua il login'
		localStorage.removeItem(AUTH_TOKEN)

		store.dispatch(signOutSuccess())
	}


	notification.error(notificationParam)

	return Promise.reject(error);
});

export default service